module.exports = __webpack_public_path__ + "img/elo.130acdea.svg";